<template>
  <div class="container">
    <el-popover
      :placement="placement"
      :title="title"
      :width="width"
      :trigger="trigger"
    >
      <slot></slot>
    </el-popover>
  </div>
</template>
<script>
export default {
  name: "custom_popover",
  props: {
    title: String,
    width: {
      type: String,
      default: "200"
    },
    placement: {
      type: String,
      default: "bottom"
    },
    trigger: {
      type: String,
      default: "click"
    }
  }
};
</script>
<style lang="scss" scoped>
</style>